import { FormikErrors } from 'formik';
import HttpError from '@web-shared/services/http-service/HttpError';
import { CreateBolFormValues } from './const';

interface ErrorsResponse {
  errors: FormikErrors<CreateBolFormValues>;
  activeStep: number;
}

type ErrorValue = string | undefined;

export const parseErrors = (err: HttpError): ErrorsResponse => {

  const errors = err.errors as Record<string, unknown> | null;

  const refNumberError = errors?.reference_number as ErrorValue;
  const locationError = errors?.site_id ? 'validation_invalid' : undefined;

  if (refNumberError || locationError) {
    return {
      errors: {
        reference_number: refNumberError,
        location: locationError
      },
      activeStep: 0
    };
  }

  // empty errors, last active step
  return { errors: {}, activeStep: 2 };
};
